module.exports = __webpack_public_path__ + "assets/img/binding-3.2bb4cbe9.jpg";